"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMeterOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zM8.52 25.37a21.1 21.1 0 0115 0 12 12 0 01-15 0zm16.53-1.52a22.55 22.55 0 00-7.46-1.79l3.3-6.61-1.78-.9L15.37 22A23 23 0 007 23.85a12 12 0 1118.1 0z" }),
        React.createElement("circle", { cx: 16, cy: 8, r: 1 }),
        React.createElement("circle", { cx: 11, cy: 10, r: 1 }),
        React.createElement("circle", { cx: 21, cy: 10, r: 1 }),
        React.createElement("circle", { cx: 8, cy: 14, r: 1 }),
        React.createElement("circle", { cx: 24, cy: 14, r: 1 })));
}
exports.default = SvgMeterOutline;
//# sourceMappingURL=MeterOutline.js.map